<template>
  <div>
    <banner v-if="!hideMyProjects" :slides="slides" :style="borderColor" :class="{'is-region': hasRegionBanner}">
      <template v-slot:title="{ title: { title: { title, image, imageAltText, className } } }">
        <template>
          <div class="header-logo">
            <img :src="image" :alt="imageAltText" :class="className"/>
          </div>
          <h2 class="title is-uppercase" :class="{'fr-title' : $i18n.locale === 'fr'}">{{ title }}</h2>
        </template>
      </template>
      <template v-slot:description="{ description: { description } }">
        <template>
          <p :class="{'fr-description' : $i18n.locale === 'fr'}" v-html="description"></p>
        </template>
      </template>
      <template v-slot:content="{ content: { content } }">
        <template v-if="content && !hasRegionBanner">
          <div class="link-container">
            <a v-if="!landingPage && $t('banners.buttons.viewProjects').length"
               @click="yscProjects" class="link is-uppercase"
               :class="{'fr-link' : $i18n.locale === 'fr'}"
               aria-label="View projects">
              {{ $t("banners.buttons.viewProjects") }}
            </a>
            <button v-if="isHomePage"
                    @click="openLearnMore"
                    class="link outline-button is-uppercase"
                    aria-label="Learn more"
                    :class="{'fr-link' : $i18n.locale === 'fr',
                    'padding-right': $t('banners.buttons.viewProjects').length}">
              {{ learnMoreText }}
            </button>
            <button v-if="landingPage"
                    @click="startNow"
                    class="link is-uppercase"
                    aria-label="Start your own project">
              {{ $t("banners.buttons.enterNow") }}
            </button>
            <button v-if="landingPage && !isLoggedIn"
                    @click="showSignup"
                    class="link outline-button padding-right is-uppercase"
                    aria-label="Start your own project">
              {{ $t("banners.buttons.getUpdates") }}
            </button>
          </div>
        </template>
      </template>
    </banner>
    <modal-learn-more v-if="showLearnModal" @close="closeLearnMore"></modal-learn-more>
  </div>
</template>

<script>
import ModalLearnMore from '@/components/Modals/LearnMore'
import i18n from '@/i18n'
import Banner from './Banner'
import categorySets from '@/mixins/category-set'

import auth from '@/mixins/auth'
import link from '@/mixins/link'
import utmTracking from '@/mixins/utm-tracking'

export default {
  mixins: [auth, link, utmTracking, categorySets],
  components: {
    Banner,
    ModalLearnMore
  },
  props: ['landingPage', 'isRegion', 'regionBanners', 'regionName', 'regionIcon'],
  data: function () {
    return {
      showLearnModal: false,
      slides: []
    }
  },
  watch: {
    $route () {
      this.getSlides()
    },
    '$i18n.locale' () {
      this.getSlides()
    }
  },
  mounted: function () {
    if (this.hasRegionBanner) {
      this.slides = []
      this.regionSlides.forEach(slide => {
        this.slides.push(slide)
      })
    } else {
      this.getSlides()
    }
  },
  computed: {
    isHomePage: function () {
      return this.$route.path === '/home' || this.$route.path.includes('/viewAll')
    },
    hideMyProjects: function () {
      return this.$route.name === 'viewAll' && this.$route.query.profile === 'mine'
    },
    learnMoreText: function () {
      return this.slides[0].content.link.text
    },
    hasRegionBanner: function () {
      return this.regionBanners?.length > 0 || null
    },
    borderColor: function () {
      return { '--border-color': this.isRegion ? '#FFC425' : '#FFF' }
    },
    regionTitle: function () {
      return `${this.regionName} ${this.fairName}`
    },
    fairName: function () {
      switch (this.regionName) {
        case 'Frontier Schools':
          return 'Division Virtual Science Fair 2021'
        case 'Frontenac, Lennox & Addington':
          return 'Science Fair'
        default:
          return 'STEM Fair'
      }
    },
    regionSlides: function () {
      const banners = []
      this.regionBanners.forEach(banner => {
        const setBanner = this.setBanner(banner)
        banners.push(setBanner)
      })
      return banners
    },
    filteredSlides: function () {
      if (this.hasRegionBanner) {
        return this.regionSlides
      } else {
        return this.slides.filter((slide, index) => this.isRegion ? index === 1 : index === 0)
      }
    },
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    }
  },
  methods: {
    reset: function () {
      this.slides.splice(0)
    },
    getSlides: async function () {
      if (this.hasRegionBanner) {
        return
      }
      this.reset()
      let bannerButtons = []
      let catBtns = null
      let catSets = null
      let partnerName = null
      await this.getCategoryObj()
      if (this.$route.name === 'region') {
        partnerName = this.appName
      } else {
        partnerName = this.appName + '-home'
      }

      catSets = await this.getCategorySetsForCategoryPage(partnerName, this.categoryID)
      catBtns = await this.getBannerButtonsForCategoryPage(partnerName, this.categoryID)

      catSets = catSets.filter(catSet => {
        if (this.$i18n.locale === 'en') {
          return (catSet.language === '' || catSet.language === '')
        } else {
          return catSet.language === 'fr'
        }
      })
      catBtns = catBtns.filter(catBtn => {
        if (this.$i18n.locale === 'en') {
          return (catBtn.language === '' || catBtn.language === '')
        } else {
          return catBtn.language === 'fr'
        }
      })

      if (catBtns) {
        const listOfUserGroups = [...new Set(catBtns.map(it => it.banner_id))]
        listOfUserGroups.forEach(function (aa, index) {
          bannerButtons[index] = catBtns.filter(e => e.banner_id === aa)
        })
      }

      for (let i = 0; i < catSets.length; i++) {
        // Initialize JSON
        const emp = {}
        emp.content = {}
        emp.content.link = {}
        emp.content.button = {}
        emp.content.button2 = {}

        emp.id = catSets[i].id
        emp.title = {
          title: catSets[i].title,
          image: catSets[i].title_image,
          imageAltText: catSets[i].title_image_alt_text
        }
        emp.description = catSets[i].description
        emp.background = {
          image: catSets[i].background_image
        }

        if (catBtns) {
          if (this.$t('banners.buttons.viewProjects').length > 0) {
            this.showLearnModal = true
            const showLearnModalButton = catBtns.filter(e => e.link === 'showLearnMoreModal')
            bannerButtons = showLearnModalButton
          } else {
            const showLink = catBtns.filter(e => e.link.includes('ysc'))
            bannerButtons = showLink
          }

          bannerButtons.forEach((bb, index) => {
            if (catSets[i].id === parseInt(bb.banner_id)) {
              if (index === 0) {
                emp.content.link.show = true
                emp.content.link.text = bb.text
                emp.content.link.url = bb.link
                emp.content.link.paramName = bb.option_name
                emp.content.link.paramValue = bb.option_value
              } else if (index === 1) {
                emp.content.button.show = true
                emp.content.button.text = bb.text
                emp.content.button.url = bb.link
                emp.content.button.paramName = bb.option_name
                emp.content.button.paramValue = bb.option_value
              } else if (index === 2) {
                emp.content.button.show = true
                emp.content.button.text = bb.text
                emp.content.button.url = bb.link
                emp.content.button.paramName = bb.option_name
                emp.content.button.paramValue = bb.option_value
              }
            }
          })
        }
        this.slides.push(emp)
      }
    },
    getCategoryObj: async function () {
      if (this.$route.params.category && this.$route.params.category.length > 0) {
        this.category = this.$route.params.category
      } else {
        this.category = this.$route.query.category
      }

      if (!this.category) {
        this.categoryID = 0
      } else {
        try {
          this.categoryObj = await this.getShowBannerForCategoryFlag(this.category)
          if (this.categoryObj === null) {
            if (this.$route.path === '/home' || this.$route.path === '/regional') {
              this.showBanners = true
            } else {
              this.showBanners = false
            }
          } else {
            this.categoryID = this.categoryObj.id
            this.showBanners = this.categoryObj.showBanner
          }
        } catch (error) {
          console.error(error)
        }
      }
    },
    yscProjects: function () {
      this.link('/viewAll/?tag=YSC', true)
    },
    startNow: function () {
      this.$emit('start')
    },
    showSignup: function () {
      this.$store.dispatch('showLoginModal', { source: 'LOGIN:{PATH}' })
    },
    openLearnMore: function () {
      if (this.$t('banners.buttons.viewProjects').length) {
        this.showLearnModal = true
        this.$store.dispatch(this.slides[0].content.link.url)
      } else {
        window.open(this.slides[0].content.link.url)
      }
    },
    closeLearnMore: function () {
      this.showLearnModal = false
    },
    bannerBlurb: function () {
      return this.landingPage ? i18n.t('banners.ysc.landing') : i18n.t('banners.ysc.home')
    },
    setBanner: function (banner) {
      const slide = {
        logo: {
          image: ''
        },
        title: {
          title: ''
        },
        background: {
          image: ''
        },
        subtitle: '',
        description: '',
        isRegion: true,
        content: {
          link1: {
            text: '',
            href: ''
          },
          link2: {
            text: '',
            href: ''
          }
        }
      }
      slide.logo.image = this.regionIcon
      slide.title.title = banner.title
      slide.background.image = banner.backgroundImage
      slide.description = banner.description
      slide.subtitle = this.regionTitle
      banner.buttons.forEach((button, index) => {
        slide.content[`link${index + 1}`].text = button.text
        slide.content[`link${index + 1}`].href = button.link
      })
      return slide
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .header-logo {
    width: 300px;
    margin-left: 3%;
    @include mobile {
      width: 200px;
      margin-bottom: 5px;
      margin-left: 3%;
    }
  }
  ::v-deep .text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 625px;
    margin: auto 0;
    margin-left: 70%;
    position: relative;
  }

  ::v-deep .title {
    font-weight: 700;
    font-size: 2.6rem;
    line-height: 3.2rem;
    letter-spacing: 0.1rem;
    color: white;
    padding-bottom: .2rem;
    margin-bottom: 0;
    text-align: left;
    margin-left: 3%;
  }

  ::v-deep .description {
    width: 100%;
    font-size: 1rem;
    line-height: 1.7rem;
    letter-spacing: 0.07rem;
    padding-top: 1.5rem;
    text-align: left;
    position: relative;
    margin-left: 3%;
    &:before {
      position: absolute;
      content: "";
      height: 2px;
      background-color: var(--border-color);
      width: 60px;
      top: 0;
      left: 0;
    }

    .fr-description {
      font-size: 0.9rem;
      line-height: 1.3rem;
    }
  }

  ::v-deep .link-container {
    display: flex;
    width: 100%;
    margin-left: 3%;

    button {
      font-weight: 600;
      cursor: pointer;
      border-radius: 0;

      &:focus,
      &:focus-within,
      &:active {
        outline: 0;
      }
    }

    .outline-button {
      background: transparent;
      border: 2px solid white;
      border-radius: 0;

      &:hover,
      &:focus,
      &:active {
        background: $primary;
      }
    }

    .padding-right {
      margin-left: 0.7rem;
    }
  }

  ::v-deep .link {
    font-size: 0.9rem;
    letter-spacing: 0.1rem;
    text-align: center;
    margin-top: 1.5rem;
    padding: 0.7rem 1rem;
    border-radius: 4px;
    border: none;
    background: $ysc-purple;
    color: white;

    -webkit-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.5);
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.5);

    &:hover,
    &:focus,
    &:active {
      background: #492984;
    }
  }

  ::v-deep .is-region {
    .wrapper {
      display: flex;
      align-items: center;
      margin: 0 auto;
      width: 95%;
      max-width: 1000px;
    }
    .region-logo {
      max-width: 190px;
      height: 190px;
      margin-right: 1.25rem;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      img {
        display: block;
        object-fit: cover;
        border-radius: 50%;
        height: 100%;
      }
    }
    .text {
      margin: 0;
      h2 {
        font-weight: 900;
        letter-spacing: 1px;
        word-spacing: 3px;
        font-size: 2rem;
        text-transform: none !important;
        max-width: 100%;
      }
    }
    .region-subtitle {
      color: #FFC425;
      font-weight: 900;
      font-size: 1.4rem;
      padding: 0.65rem 0;
      white-space: nowrap;
      margin-left: 3%;
    }
    .description {
      padding-top: 0;
      font-size: 1.2rem;
      &:before {
        position: absolute;
        content: "";
        height: 0;
        background-color: transparent;
        width: 0;
        top: 0;
        left: 0;
      }
    }
    .link-container {
      .link {
        border-radius: 0;
        text-transform: uppercase;
      }
      a:first-of-type {
        margin-right: 0.5rem;
      }
    }
    @include mobile {
      .wrapper {
        width: 95%;
      }
      .text {
        h2 {
          font-size: 2rem;
          word-spacing: 1px;
        }
      }
      .region-logo {
        max-width: 100px;
        height: 100px;
        margin-right: 1rem;
      }
      .region-subtitle {
        text-transform: uppercase;
        font-size: 2rem;
        padding: 0;
      }
    }
    @media (max-width: 487px) {
      .wrapper {
        flex-direction: column;
      }
      .region-logo {
        margin-right: 0;
      }
      .text {
        display: flex;
        flex-direction: column;
        align-items: center;
        h2 {
          text-align: center;
        }
      }
      .link-container {
        display: flex;
        justify-content: center;
      }
   }
  }

  @include tablet {
    ::v-deep .text{
      margin-left: 5% !important;
    }
    ::v-deep .title {
      font-size: 2rem;
      padding-bottom: .5rem;
    }
  }

  @include touch {
    ::v-deep .text {
      width: 60%;
      margin: auto 5%;
    }
  }

  @include mobile {
    img {
      &.regionsLogo {
        width: 50px;
      }
    }
    ::v-deep .text {
      width: 70%;
      margin: auto 5%;

     .title {
       font-size: 1.5rem;
       line-height: 2rem;
       padding-bottom: .5rem;
       margin-bottom: 0;

       .fr-title {
         font-size: 1.5rem;
       }
     }
    }
    ::v-deep .description {
      width: 100%;
      line-height: 1.3rem;
      font-size: .9rem;

      .fr-description {
        width: 100%;
      }
    }
    ::v-deep .link {
      font-size: 0.85rem;

      &.fr-link {
        padding: 0.5rem 0.7rem;
      }
    }
    ::v-deep .slide1 {
      background-position: 0;
    }
  }

  @media (max-width: 400px) {
    ::v-deep .link {
      margin-top: 0.7rem;
    }
  }

  @media (max-width: 360px) { // Very small mobile (iPhone 5). mini-mobile wasn't working here.
    ::v-deep .title {
      .fr-title {
        font-size: 1.2rem;
      }
    }
    ::v-deep .text {
      margin-left: 5%;
    }
    ::v-deep .description {
      line-height: 1.2rem;
      font-size: .8rem;

      .fr-description {
        line-height: 1.1rem;
      }
    }
    ::v-deep .link {
      font-size: .7rem;
      padding: .7rem .7rem;
    }
  }
</style>
